import mapperIcon from '../../utils/mappers/mapper-icon'

/**
 * Product updates products
 * @param {Object} data - cms response data
 * @return {Object} the normalized data
 */

export const mapperProductUpdatesProduct = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data?.sys?.id || '',
    name: data?.name || '',
    contentType: data?.contentType || '',
    icon: mapperIcon(data?.icon)
  }
}
